import type { ProductOut } from "@/lib/api";

/**
 * Prezzo sotto il floor di margine, per colorare la cella in tabella. Viene dalla
 * classificazione del backend: `sotto_margine` (offerta in vendita, prezzo non
 * bloccato a mano) oppure `riapre_sotto_margine` (offerta spenta che riaprirebbe in
 * perdita). Il contatore e il filtro "Sotto margine" usano solo `sotto_margine`.
 */
export function isBelowMargin(p: Pick<ProductOut, "sotto_margine" | "riapre_sotto_margine">): boolean {
  return p.sotto_margine || p.riapre_sotto_margine;
}
